const keyMap = {
  13: "OK",
  8: "BACK",
  38: "ARROW_UP",
  39: "ARROW_RIGHT",
  40: "ARROW_DOWN",
  37: "ARROW_LEFT",
  412: "MEDIA_REWIND",
  417: "MEDIA_FAST_FORWARD",
  415: "MEDIA_PLAY",
  413: "MEDIA_STOP",
  19: "MEDIA_PAUSE",
  463 : "MEDIA_PLAY_PAUSE",

  // FIXME: For debugging purposes
  "CTRL+8": "BACK",
  "ALT+8": "BACK"
};

export default {
  keyMap
};
